//any type checked blueice
import { TranslatableString } from '../shared/model/translateble-string.model';

export interface ISubjectCategory {
    id?: string;
    name?: string;
    code?: string;
    active?: boolean;
    translateName?: TranslatableString[];
    uuid?: string;
    revisionId?: string;
    changedDate?: Date;
    changedBy?: string;
    createdDate?: Date;
    createdBy?: string;
}

export class SubjectCategory implements ISubjectCategory {
    constructor(
        public id?: string,
        public name?: string,
        public code?: string,
        public active?: boolean,
        public translateName?: TranslatableString[],
        public uuid?: string,
        public revisionId?: string,
        public changedDate?: Date,
        public changedBy?: string,
        public createdDate?: Date,
        public createdBy?: string
    ) {
        this.id = id ? id : null;
        this.name = name ? name : '';
        this.code = code ? code : '';
        this.active = active ? active : true;
        this.translateName = translateName ? translateName : [];
        this.uuid = uuid ? uuid : null;
        this.revisionId = revisionId ? revisionId : null;
        this.changedDate = changedDate ? changedDate : null;
        this.changedBy = changedBy ? changedBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.createdBy = createdBy ? createdBy : null;
    }
}
